import { render, staticRenderFns } from "./ProjectCostsCalculatedTable.vue?vue&type=template&id=452c30ee&scoped=true&"
import script from "./ProjectCostsCalculatedTable.vue?vue&type=script&lang=js&"
export * from "./ProjectCostsCalculatedTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCostsCalculatedTable.vue?vue&type=style&index=0&id=452c30ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c30ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout})
